import { render } from "./BuilderFiltersHousesModal.vue?vue&type=template&id=39cc2986&scoped=true&ts=true&lang=pug"
import script from "./BuilderFiltersHousesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderFiltersHousesModal.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderFiltersHousesModal.vue?vue&type=style&index=0&id=39cc2986&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cc2986"]])

export default __exports__